export enum AppSettingsQueryKeys {
  AppSettings = "appSettings",
  VisibleAppSettings = "visibleAppSettings",
  SettingAudits = "settingAudits",
}
